<h2 mat-dialog-title>Impossible de délier le bâtiment</h2>
<mat-dialog-content>
  <p>Les activités suivantes sont associées à une adresse de ce bâtiment&nbsp;:</p>
  <ul class="list-disc pl-4">
    <li *ngFor="let activity of activities">{{ activity.label }}</li>
  </ul>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Fermer</button>
</mat-dialog-actions>
